var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "url(#paint0_linear_1141_3388)",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 18.6999L27.2333 22.1833C26.5333 25.1916 25.15 26.4083 22.55 26.1583C22.1333 26.1249 21.6833 26.0499 21.2 25.9333L19.8 25.5999C16.325 24.7749 15.25 23.0583 16.0667 19.5749L16.8833 16.0833C17.05 15.3749 17.25 14.7583 17.5 14.2499C18.475 12.2333 20.1333 11.6916 22.9167 12.3499L24.3083 12.6749C27.8 13.4916 28.8667 15.2166 28.05 18.6999Z",
    stroke: "#FBBF24",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5498 26.1583C22.0331 26.5083 21.3831 26.8 20.5915 27.0583L19.2748 27.4917C15.9665 28.5583 14.2248 27.6667 13.1498 24.3583L12.0831 21.0667C11.0165 17.7583 11.8998 16.0083 15.2081 14.9417L16.5248 14.5083C16.8665 14.4 17.1915 14.3083 17.4998 14.25C17.2498 14.7583 17.0498 15.375 16.8831 16.0833L16.0665 19.575C15.2498 23.0583 16.3248 24.775 19.7998 25.6L21.1998 25.9333C21.6831 26.05 22.1331 26.125 22.5498 26.1583Z",
    stroke: "#FBBF24",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5332 17.1084L24.5749 18.1334",
    stroke: "#FBBF24",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7168 20.333L22.1335 20.9497",
    stroke: "#FBBF24",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1141_3388",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg2);
export default __webpack_public_path__ + "static/media/cardImg2.3feba62bb2dbdcf5b3b3a0ac57e474fe.svg";
export { ForwardRef as ReactComponent };